// i18n.config.ts
export default {
  fallbackLocale: "pt",
};
